import React from 'react';
import { useTheme } from '../ThemeContext';

function ThemeToggle() {
    const { theme, toggleTheme } = useTheme();

    return (
        <button
            className="theme-toggle"
            onClick={toggleTheme}
            title={theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
        >
            {theme === 'dark' ? (
                <i className="bi bi-sun-fill"></i>
            ) : (
                <i className="bi bi-moon-fill"></i>
            )}
        </button>
    );
}

export default ThemeToggle;
